module.exports = __webpack_public_path__ + "static/hhkb-8cf3ccc199838e244bbad5fe07e32666.jpg";